<template>
  <main>
    <h1>Formulaire Validé</h1>
  </main>
</template>
<script>
export default {
  name: 'play'
}
</script>